<script setup lang="ts">

import GenericIconWithColoredNumber from '@/components/Elements/Images/Icons/GenericIconWithColoredNumber.vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { CDN } from '@/models/cdn.ts'
import { useGameStore } from '@/stores/gameStore.ts'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

/**
 * Stores / models
 */
const gameStore = useGameStore()

/**
 * Props
 */
defineProps({
  component: {
    type: Object,
    required: true
  }
});

/**
 * Computed
 */
const colonizationPodSpeedLimit = computed(() => {
  // Check if player has the settlers_can_reach_speed_3 minister
  if (gameStore.playerMinisters.has('settlers_can_reach_speed_3')) {
    return 3
  }
  return 2
})

</script>

<template>
  <StandardCard :title="t(`shipComponents.shipComponents.${component.code}.name`)" top-padding="0" bottom-padding="0">
    <div class="relative group">
      <!-- Top Gradient -->
      <div class="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/100 to-transparent pointer-events-none rounded-t"></div>
      <!-- Bottom Gradient -->
      <div class="absolute hidden group-hover:flex inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/100 to-transparent pointer-events-none rounded-b"></div>

      <!-- Colopod Speed Limit Message -->
      <div v-if="component.code === 'colonization_pod'" class="absolute top-1 left-0 right-0 flex justify-center pointer-events-none z-10">
        <div class="text-red-500 px-3 rounded text-sm font-semibold">
          {{ t('modals.createShipDesign.limitsSpeed', { speed: colonizationPodSpeedLimit }) }}
        </div>
      </div>

      <!-- Top Effects -->
      <div class="absolute top-0 flex justify-between w-full p-1">
        <template v-for="effect in component.effects" :key="effect.type">
          <div v-if="effect.modifier > 0 && effect.type != 'ship_mass' && effect.type != 'ship_production_cost'">
            <GenericIconWithColoredNumber :amount="effect.modifier" :type="effect.type" class="p-1" />
          </div>
        </template>
      </div>

      <!-- Bottom Effects -->
      <div class="absolute bottom-0 hidden group-hover:flex justify-between w-full p-1">
        <template v-for="effect in component.effects" :key="effect.type">
          <div v-if="effect.modifier > 0 && (effect.type == 'ship_mass' || effect.type == 'ship_production_cost')">
            <GenericIconWithColoredNumber :amount="effect.modifier" :type="effect.type" class="p-1" />
          </div>
        </template>
      </div>

      <!-- Component Image -->
      <img class="rounded" :src="CDN.shipComponent(512, component.code)" alt="" />
    </div>
    <div class="pt-2">
      <slot></slot>
    </div>
  </StandardCard>
</template>


<style scoped lang="scss">

</style>